import request from '@/utils/request'

// 쿼리 메뉴 목록
export function listMenu(query) {
  return request({
    url: '/system/menus',
    method: 'get',
    params: query
  })
}

// 쿼리 메뉴 세부정보
export function getMenu(mnuId) {
  return request({
    url: '/system/menus/' + mnuId,
    method: 'get'
  })
}

// 쿼리 메뉴 드롭다운 트리 구조
export function treeselect() {
  return request({
    url: '/system/menus/treeselect',
    method: 'get'
  })
}

// 역할 ID에 따른 쿼리 메뉴 드롭다운 트리 구조
export function roleMenuTreeselect(roleId) {
  return request({
    url: '/system/menus/role-menu-treeselect/' + roleId,
    method: 'get'
  })
}

// 새로운 메뉴
export function addMenu(data) {
  return request({
    url: '/system/menus',
    method: 'post',
    data: data
  })
}

// 메뉴 수정
export function updateMenu(data) {
  return request({
    url: '/system/menus',
    method: 'put',
    data: data
  })
}

// 메뉴 삭제
export function delMenu(menuId) {
  return request({
    url: '/system/menus/' + menuId,
    method: 'delete'
  })
}
